import { useRouter } from "@/app/hooks/useRouter";
import AppointmentOverBookingV2RequestPage from ".";
import { useLocation, useNavigate } from "react-router";
import { IOverbookingRequestRouteLocationState } from "./helpers";

const useOverbookingRequestRouteContext = () => {
  const { getRouteKey } = useRouter();
  const location = useLocation();
  const routeLocationState = (location.state as IOverbookingRequestRouteLocationState | null) ?? null;
  const searchParams = new URLSearchParams(location.search);
  const clinicId = routeLocationState?.initialFilters?.clinicId || searchParams.get("clinicId") || "";
  const type = routeLocationState?.initialFilters?.type || searchParams.get("type") || "";
  const date = routeLocationState?.initialFilters?.date || "";
  const backParams = new URLSearchParams(searchParams);
  backParams.delete("requestId");
  backParams.delete("date");
  const backQueryString = backParams.toString();
  const listUrl =
    routeLocationState?.listUrl ||
    `${getRouteKey("OVERBOOKING_V2", "url")}${backQueryString ? `?${backQueryString}` : ""}`;

  return {
    clinicId,
    type,
    date,
    listUrl,
    requestData: routeLocationState?.requestData ?? null,
  };
};

export const AppointmentOverBookingV2CreateRequestRoute = () => {
  const navigate = useNavigate();
  const { listUrl } = useOverbookingRequestRouteContext();

  return (
    <AppointmentOverBookingV2RequestPage
      mode="new"
      onCancel={() => navigate(listUrl)}
      onSaved={() => navigate(listUrl)}
    />
  );
};

export const AppointmentOverBookingV2UpdateRequestRoute = () => {
  const navigate = useNavigate();
  const { clinicId, type, date, listUrl, requestData } = useOverbookingRequestRouteContext();

  return (
    <AppointmentOverBookingV2RequestPage
      mode="update"
      requestData={requestData}
      initialFilters={{ clinicId, type, date }}
      onCancel={() => navigate(listUrl)}
      onSaved={() => navigate(listUrl)}
    />
  );
};
